module.exports = __webpack_public_path__ + "assets/pdf/user-manual.300f25eb.pdf";